import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GoogleTagManagerEventAction } from '../../enums';
import { EmailCollectorViewModel } from './email-collector.view-model';

@Injectable()
export abstract class AbstractEmailCollectorService {
  protected readonly noWhiteSpaceRegex = new RegExp(/\s/);
  public abstract readonly showTickMark$: Observable<boolean>;
  public isRegisteredCredential?: boolean;

  public abstract startFreeTrial$(
    vm: EmailCollectorViewModel,
    email: string,
    password: string,
    voucher?: string,
    bin?: string
  ): Observable<EmailCollectorViewModel>;
  public abstract showMobileProviderButton$: Observable<boolean>;
  public abstract isLoading$: Observable<boolean>;
  public abstract measureStartFreeTrialButtonClick(
    stepName: string,
    buttonText: string,
    displayOnDialog: boolean,
    eventAction: GoogleTagManagerEventAction,
    contentTitle?: string
  ): void;
  public abstract measureSignUpWithMobileProviderButtonClick(buttonText: string, displayOnDialog: boolean, contentTitle?: string): void;
}
